import { Pipe, PipeTransform } from '@angular/core';
import { InvoiceModel } from '../models/invoice.model';
import { SubscriptionModel } from '../models/subscription.model';

@Pipe({
    name: 'invoices'
})
export class InvoicesFilter  implements PipeTransform {
    transform(invoices: InvoiceModel[], subscriptions: SubscriptionModel[]) {
        const filtered: InvoiceModel[] = [];
        if (invoices != null && invoices.length > 0) {
            invoices.forEach(invoice => {
                if (subscriptions && subscriptions.length > 0) {
                    for (let s = 0; s < subscriptions.length; s++) {
                        const subscription = subscriptions[s];
                        if (invoice.subscription && subscription.id === invoice.subscription.id) {
                            filtered.push(invoice);
                            break;
                        }
                    }
                } else {
                    filtered.push(invoice);
                }
            });
        }
        return filtered;
    }
}
